var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClassroomUnavailable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 219,
    viewBox: "0 0 250 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.13 9.55859H12.3857V145.893H239.13V9.55859Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.76 159.878C128.76 160.637 128.535 161.378 128.113 162.008C127.692 162.638 127.093 163.129 126.392 163.418C125.692 163.707 124.921 163.782 124.177 163.633C123.434 163.484 122.752 163.118 122.217 162.581C121.682 162.044 121.318 161.36 121.172 160.616C121.026 159.872 121.104 159.102 121.397 158.402C121.689 157.703 122.182 157.106 122.814 156.687C123.446 156.268 124.187 156.046 124.946 156.049C125.448 156.049 125.945 156.148 126.409 156.341C126.873 156.533 127.294 156.816 127.648 157.171C128.002 157.527 128.283 157.95 128.474 158.414C128.665 158.879 128.762 159.376 128.76 159.878V159.878Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.786 207.136H95.1055L99.1802 173.986H150.712L154.786 207.136Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.63 207.275H66.2295V216.972H183.63V207.275Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M241.765 1.59375H8.12739C4.74333 1.59375 2 4.33708 2 7.72114V167.891C2 171.275 4.74333 174.019 8.12739 174.019H241.765C245.149 174.019 247.892 171.275 247.892 167.891V7.72114C247.892 4.33708 245.149 1.59375 241.765 1.59375Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M124.947 136.504C157.612 136.504 184.092 110.024 184.092 77.3595C184.092 44.6948 157.612 18.2148 124.947 18.2148C92.2827 18.2148 65.8027 44.6948 65.8027 77.3595C65.8027 110.024 92.2827 136.504 124.947 136.504Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2732 57.4076C88.897 56.0314 86.5912 56.3104 85.7317 58.0565C82 65.6375 80.5329 74.1657 81.5531 82.6085C82.7267 92.3214 87.1244 101.36 94.0424 108.278C100.96 115.196 109.999 119.594 119.712 120.767C128.155 121.787 136.683 120.32 144.264 116.589C146.01 115.729 146.289 113.423 144.913 112.047L90.2732 57.4076Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.262 39.3943C102.7 39.7152 102.608 40.4814 103.066 40.9394L161.347 99.2355C161.805 99.6935 162.571 99.602 162.892 99.0395C167.53 90.9132 169.443 81.5017 168.332 72.1891C167.169 62.4551 162.77 53.3941 155.839 46.4613C148.908 39.5286 139.848 35.1265 130.114 33.962C120.802 32.8479 111.39 34.759 103.262 39.3943Z",
    stroke: "#9FA5B4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroomUnavailable);
export default __webpack_public_path__ + "static/media/classroomUnavailable.399e27f0.svg";
export { ForwardRef as ReactComponent };